<template>
  <select class="form-select" name="ArrangementType" @change="change">
    <option
      v-for="(option, index) in options"
      :key="index"
      :value="option.kode"
      :selected="selectedOption(option)"
    >
      {{ option.tekst }}
    </option>
  </select>
</template>
<!--:selected="selectedOption(option)"-->
<script>
export default {
  name: "Tidspunkt",
  props: ["value"],

  data() {
    return {
      options: [
        { kode: 0, tekst: "00:00" },
        { kode: 1, tekst: "01:00" },
        { kode: 2, tekst: "02:00" },
        { kode: 3, tekst: "03:00" },
        { kode: 4, tekst: "04:00" },
        { kode: 5, tekst: "05:00" },
        { kode: 6, tekst: "06:00" },
        { kode: 7, tekst: "07:00" },
        { kode: 8, tekst: "08:00" },
        { kode: 9, tekst: "09:00" },
        { kode: 10, tekst: "10:00" },
        { kode: 11, tekst: "11:00" },
        { kode: 12, tekst: "12:00" },
        { kode: 13, tekst: "13:00" },
        { kode: 14, tekst: "14:00" },
        { kode: 15, tekst: "15:00" },
        { kode: 16, tekst: "16:00" },
        { kode: 17, tekst: "17:00" },
        { kode: 18, tekst: "18:00" },
        { kode: 19, tekst: "19:00" },
        { kode: 20, tekst: "20:00" },
        { kode: 21, tekst: "21:00" },
        { kode: 22, tekst: "22:00" },
        { kode: 23, tekst: "23:00" },
      ],
    };
  },
  methods: {
    selectedOption(option) {
      if (this.value) {
        return option.kode == this.value;
      }
      return false;
    },
    change(e) {
      const selectedCode = e.target.value;

      const option = this.options.find((option) => {
        return selectedCode == option.kode;
      });
      this.$emit("input", option.kode);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>